// extracted by mini-css-extract-plugin
module.exports = {"buildcontrols":"buildcontrols_buildcontrols__U3geH","OrderButton":"buildcontrols_OrderButton__2SQqX","enable":"buildcontrols_enable__2o0Yr"};